export default "__VITE_ASSET__985f1971__"